import { useNavigate, useParams } from "react-router-dom";
import { useStore } from "../../../Components/StateProvider";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import {
  baseurl,
  ErrorAlert,
  GetDateTimeFormat,
  GetRecords,
  RupeeFormat,
  UploadFile,
  WarningAlert,
} from "../../../functions/api";
import AccountsLayout from "../AccountsLayout";
import FormView from "../../../Components/Elements/FormView";
import { MdOutlineFileUpload } from "react-icons/md";
import { FaRegEye } from "react-icons/fa6";
import {
  HiOutlineArrowTrendingUp,
  HiOutlineCheckCircle,
  HiOutlineArrowTrendingDown,
} from "react-icons/hi2";

const BudgetActual = () => {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const getrecord = `/users/users/${companyId}`;
  const attachment_Prefix = "Journal_";
  const store = useStore();
  const statusStyles = {
    "Over Budget": {
      bg: "bg-red-100",
      text: "text-red-600",
      icon: <HiOutlineArrowTrendingUp className="w-5 h-5 text-[#FF0000]" />,
    },
    "On Track": {
      bg: "bg-green-100",
      text: "text-green-600",
      icon: <HiOutlineCheckCircle className="w-5 h-5 text-[#22C55E]" />,
    },
    "Under Budget": {
      bg: "bg-orange-100",
      text: "text-orange-600",
      icon: <HiOutlineArrowTrendingDown className="w-5 h-5 text-[#F97316]" />,
    },
  };
  // *initial values
  const init = {
    entries: [],
    totalDebit: [],
    totalCredit: [],
    budgetAmount: [],
    actualAmount: [],
    variance: [],
    variancePercentage: [],
    status: [],
    fromDate: "",
    ToDate: "",
  };

  const [Record, setRecord] = useState(init);

  useEffect(() => {
    store.setmodule("budgetactual", init);
    const dateTime = GetDateTimeFormat();
    handleMultiFieldChange({
      fromDate: dateTime.yearStartDate + "Z",
      ToDate: dateTime.yearEndDate + "Z",
    });
    loadRecord(dateTime.yearStartDate + "Z", dateTime.yearEndDate + "Z");
  }, []);

  function loadRecord(fromDate, ToDate) {
    GetRecords(
      `/api/v2/accounting/budgetactual/${companyId}?startDate=${
        fromDate || Record.fromDate
      }&endDate=${ToDate || Record.ToDate}`
    ).then((res) => {
      if (res.success) {
        res = res.record;
        handleMultiFieldChange({
          entries: res.entries,
          budgetAmount: res.budgetAmount,
          totalDebit: res.totalDebit,
          totalCredit: res.totalCredit,
          actualAmount: res.actualAmount,
          variance: res.variance,
          variancePercentage: res.variancePercentage,
          status: res.status,
        });
      }
    });
  }

  function handleMultiFieldChange(value = {}) {
    setRecord((prev) => {
      return { ...prev, ...value };
    });
  }

  return (
    <>
      <div className="flex px-10 gap-3 py-1 bg-secondary justify-center items-center border-b border-Old_Silver">
        <div className="flex text-[14px] w-full h-full px-3 flex-row items-center gap-3">
          <label className="w-fit min-w-[100px] max-w-full">From Date</label>
          <input
            className="w-full border-b border-Old_Silver border-opacity-35 font-medium px-2 py-1"
            type="date"
            value={Record.fromDate.split("T")[0]}
            onChange={(event) => {
              handleMultiFieldChange({
                fromDate: event.target.value + "T00:00:00Z",
              });
              loadRecord(event.target.value + "T00:00:00Z", Record.ToDate);
            }}
          />
        </div>
        <div className="flex text-[14px] w-full h-full px-3 flex-row items-center gap-3">
          <label className="w-fit min-w-[100px] max-w-full">To Date</label>
          <input
            className="w-full border-b border-Old_Silver border-opacity-35 font-medium px-2 py-1"
            type="date"
            value={Record.ToDate.split("T")[0]}
            onChange={(event) => {
              handleMultiFieldChange({
                ToDate: event.target.value + "T23:59:59Z",
              });
              loadRecord(Record.fromDate, event.target.value + "T23:59:59Z");
            }}
          />
        </div>
      </div>
      <div className="flex h-[90%] px-6 pt-2 bg-secondary rounded-lg overflow-x-auto">
        <div className="w-fit p-2">
          <table className="w-fit max-w-full">
            <thead className="bg-Azureish_White">
              <th className="min-w-[400px] text-left pl-2">Ledger Name</th>
              <th className="min-w-[160px] text-left pl-2 border-l">
                Budget Amount
              </th>
              <th className="min-w-[160px] text-left pl-2 border-l">
                Actual Amount
              </th>
              <th className="min-w-[160px] text-left pl-2 border-l">
                Variance
              </th>
              <th className="min-w-[160px] text-left pl-2 border-l">
                Variance Percentage
              </th>
              <th className="min-w-[160px] text-left pl-2 border-l">Status</th>
            </thead>
            <tbody>
              {Record.entries.map((item, index) => (
                <tr
                  key={index}
                  className="border-b border-tertiary hover:bg-Azureish_White cursor-pointer"
                >
                  <td className="min-w-[400px] text-left pl-2">
                    {item.ledgerName}
                  </td>
                  <td className="min-w-[160px] px-2 pt-1 border-l text-primary font-semibold">
                    {RupeeFormat(item.budgetAmount)}
                  </td>
                  <td className="min-w-[160px] px-2 pt-1 border-l text-primary font-semibold">
                    {RupeeFormat(item.actualAmount)}
                  </td>
                  <td className="min-w-[160px] px-2 pt-1 border-l text-primary font-semibold">
                    {RupeeFormat(item.variance)}
                  </td>
                  <td className="min-w-[160px] px-2 pt-1 border-l text-primary font-semibold">
                    {RupeeFormat(item.variancePercentage)}
                  </td>
                  <td className="min-w-[160px] px-2 pt-1 border-l font-semibold">
                    <span
                      className={`flex items-center gap-2 px-2 py-1 rounded-lg text-sm font-semibold ${
                        statusStyles[item.status]?.bg
                      } ${statusStyles[item.status]?.text}`}
                    >
                      {statusStyles[item.status]?.icon} {item.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default BudgetActual;
